import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UnsubscribeService } from '@app/shared/services/api/unsubscribe.service';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {
  loading = true;
  success = false;
  message = '';
  patientName: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private unsubscribeService: UnsubscribeService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const patientId = params['patient_id'];
      const token = params['unsubscribeToken'];

      if (!patientId || !token) {
        this.loading = false;
        this.success = false;
        this.message = 'Invalid unsubscribe link. Missing required parameters.';
        return;
      }

      this.unsubscribe(parseInt(patientId, 10), token);
    });
  }

  unsubscribe(patientId: number, token: string): void {
    this.unsubscribeService.unsubscribe(patientId, token).subscribe(
      (response: any) => {
        this.loading = false;
        if (response && response.success) {
          this.success = true;
          this.message = response.message || 'You have been successfully unsubscribed from email notifications.';
          this.patientName = response.patient_name || null;
        } else {
          this.success = false;
          this.message = response?.message || 'Failed to unsubscribe. Please try again later.';
        }
      },
      (error: any) => {
        this.loading = false;
        this.success = false;
        const errorMessage = error?.error?.message || error?.message || 'An error occurred while processing your request. Please try again later.';
        this.message = errorMessage;
        console.error('Unsubscribe error:', error);
      }
    );
  }
}

